import { render, staticRenderFns } from "./EditPlatform.vue?vue&type=template&id=854edc76&scoped=true&"
import script from "./EditPlatform.vue?vue&type=script&lang=js&"
export * from "./EditPlatform.vue?vue&type=script&lang=js&"
import style0 from "./EditPlatform.vue?vue&type=style&index=0&id=854edc76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854edc76",
  null
  
)

export default component.exports